import {jsonRoute} from '@github-ui/react-core/json-route'
import {registerDataRouterApp, registerNavigatorApp} from '@github-ui/react-core/register-app'
import {App} from './App'
import {PullRequestErrorState} from './components/PullRequestErrorState'
import {pullRequestsAppBuilder} from './config/app-builder'
import {CommitsEntrypoint} from './routes/Commits'
import {pullRequestsCommitsRoute} from './routes/commits-route'
import {CommitsEntrypointFuture} from './routes/CommitsFuture'
import {FilesEntrypoint} from './routes/Files'

// This app registers the app *twice*, under the same name: 'pull-requests'.
// Once as a navigator app, and once as a data router app.
// At runtime, a feature flag determines which app is used.

registerNavigatorApp('pull-requests', () => ({
  App,
  routes: [
    jsonRoute({path: '/:owner/:repo/pull/:pr_number/commits', Component: CommitsEntrypoint}),
    jsonRoute({path: '/:owner/:repo/pull/:pr_number/files', Component: FilesEntrypoint}),
  ],
}))

// Below is the new way to register an app. I.e with the data router.

export const pullRequestsApp = pullRequestsAppBuilder.createDataRouterAppFromRoutes([
  pullRequestsCommitsRoute.toRoute({
    ErrorBoundary: PullRequestErrorState,
    Component: CommitsEntrypointFuture,
  }),
])

registerDataRouterApp(pullRequestsApp)
